<bb-retail-layout [displayNotificationSettingsButton]="displayNotificationSettingsButton$ | async">
  <bb-navigation-menu></bb-navigation-menu>
  <ng-container *bbIfEntitlements="permissions.canViewRealTimeCommunicationChat">
    <bb-rtc-chat-button></bb-rtc-chat-button>
    <bb-retail-chat-conversation></bb-retail-chat-conversation>
  </ng-container>
  <!-- Show downtime banner -->

  <!-- <bb-alert-ui *ngIf="downTimeType === 0" [title]="bannerMessage" modifier="warning">
  </bb-alert-ui> -->
  <!-- <div class="spinner-container" *ngIf="isLoading$ | async">
    <bb-loading-indicator-ui inline="true"></bb-loading-indicator-ui>
  </div> -->
  <!-- Hide feature depending on status -->
  <div *ngIf="!(isUniTrustPage && (unitTrustStatus === 1 || unitTrustStatus === 2))">
    <router-outlet></router-outlet>
    <ng-container>
      <ng-container *ngComponentOutlet="chatPanel | async"></ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="isUniTrustPage && (unitTrustStatus === 1 || unitTrustStatus === 2)">
    <h1>Stanbic Unit Trust Funds</h1>
    <div class="card card-body">
      <bb-alert-ui title="Stanbic Unit Trust Funds" [modifier]="unitTrustStatus === 1 ? 'warning' : 'error'">
        <span>{{ unitTrustStatusDescription }}</span>
      </bb-alert-ui>
    </div>
  </ng-container>

  <a class="whatsapp-fab" [attr.href]="whatsAppLink" target="_blank" rel="noopener noreferrer"
    aria-label="Chat on WhatsApp">
    <span class="whatsapp-fab__label">
      <img src="./assets/images/icn_whatsapp.svg" alt="whatsapp icon">
    </span>
  </a>
</bb-retail-layout>